"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPhoneNumber = exports.isValidMobileNumber = exports.formatPhoneNumberForApi = void 0;
const mobile_1 = __importDefault(require("libphonenumber-js/mobile"));
const formatString_1 = require("./formatString");
/**
 *
 * @param {string} value - The string to extract a phone number from (ex. '+1 512 867 5309')
 * @param {string} countryCode - The 2 digit country code
 * @return {string} The phone number without the country code (ex. '5128675309')
 */
const formatPhoneNumberForApi = (value, countryCode = 'US') => {
    const phoneNumber = mobile_1.default(value, {
        defaultCountry: countryCode,
    });
    // TODO: use phoneNumber.number when the API can support country codes
    return phoneNumber.nationalNumber;
};
exports.formatPhoneNumberForApi = formatPhoneNumberForApi;
const isValidMobileNumber = (value) => {
    return mobile_1.default(value).isValid();
};
exports.isValidMobileNumber = isValidMobileNumber;
const formatPhoneNumber = (phoneNumber = '', countryCode = 1) => {
    if (!phoneNumber) {
        return '';
    }
    // if any country code is already on phone number
    if (phoneNumber.startsWith('+')) {
        // check if country code matches function arg
        if (Number.parseInt(phoneNumber.charAt(1)) !== countryCode) {
            // replace country code with one matching function arg
            return `+${countryCode} ${formatString_1.formatString('XXX-XXX-XXXX', phoneNumber)}`;
        }
        // only format phone number after country code addition
        return `+${countryCode} ${formatString_1.formatString('XXX-XXX-XXXX', phoneNumber.substr(3))}`; // subStr(3) grabs everything after `+${countryCode} `
    }
    return `+${countryCode} ${formatString_1.formatString('XXX-XXX-XXXX', phoneNumber)}`;
};
exports.formatPhoneNumber = formatPhoneNumber;
